<template>
  <div>
    <v-data-table
      dense
      :headers="headers"
      :items="desserts"
      :search="searchBankCS"
      class="elevation-1"
      :sort-by.sync="sortBankCS"
      :sort-desc.sync="sortBankDesc"
      :items-per-page.sync="updateBankItemsPerPage"
      @update:sort-by="OnBankSortBy($event)"
      @update:sort-desc="OnBankSortDesc($event)"
      @update:items-per-page="OnUpdateBankItemsPerPage($event)"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <!-- <v-toolbar-title>Банки</v-toolbar-title> -->
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <!-- <v-spacer></v-spacer> -->
          <v-text-field
            v-model="searchBankCS"
            append-icon="search"
            clearable
            label="Поиск ..."
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn class="mb-2" @click="AddBank" v-if="!checkRole(roleObj.bank)"
            ><v-icon left>add</v-icon>Добавить банк</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:item.outside_request="{ item }">
        <template v-if="item.outside_request">
          <v-chip
            x-small
            :color="getColor(item.outside_request)"
            class="white--text"
            >{{ getBool(item.outside_request) }}</v-chip
          >
        </template>
        <template v-else>
          <v-chip x-small :color="getColor(item.outside_request)">{{
            getBool(item.outside_request)
          }}</v-chip>
        </template>
      </template>
      <template v-slot:item.active="{ item }">
        <template v-if="item.active">
          <v-chip x-small :color="getColor(item.active)" class="white--text">{{
            getBool(item.active)
          }}</v-chip>
        </template>
        <template v-else>
          <v-chip x-small :color="getColor(item.active)">{{
            getBool(item.active)
          }}</v-chip>
        </template>
      </template>
      <template v-slot:item.action="{ item }">
        <div style="display: flex; justify-content: center">
          <v-icon small class="mr-2" @click="editItem(item)"> edit </v-icon>
          <v-icon
            small
            @click="deleteItem(item)"
            v-if="!checkRole(roleObj.bank)"
          >
            delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      bottom
      color="deep-purple accent-4"
    ></v-progress-linear>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { roleObj } from "../../plugins/roles";
export default {
  data: () => ({
    roleObj,
    searchBankCS: "",
    sortBankCS: "license",
    sortBankDesc: true,
    updateBankItemsPerPage: 15,
    dialog: false,
    loading: false,
    headers: [
      {
        text: "Название",
        align: "left",
        sortable: false,
        value: "name",
      },
      { text: "ИНН Банка", value: "inn" },
      { text: "Лицензия", value: "license" },
      { text: "Рейтинг Акра", value: "acra" },
      { text: "Рейтинг Эксперт РА", value: "raexpert" },
      { text: "Рейтинг НРА", value: "npa" },
      { text: "Рейтинг НКР", value: "nkp" },
      { text: "Рассмотрение нестандартн. Заявок", value: "outside_request" },
      { text: "Активен", value: "active" },
      { text: "Время ред.", value: "updated_at" },
      { text: "Действия", value: "action", sortable: false },
    ],
    //desserts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
  }),

  computed: {
    desserts() {
      return this.$store.getters.getBanksCS;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    //this.initialize()
    this.sortBankCS = this.$store.getters.getSortBankCS;
    this.sortBankDesc = this.$store.getters.getSortDescBankCS;
    this.searchBankCS = this.$store.getters.getSearchBankCS;
    this.updateBankItemsPerPage = this.$store.getters.getBankPerPage;
  },

  methods: {
    OnBankChangeSearch(evt) {
      this.searchBankCS = evt;
      this.$store.commit("SET_SEARCH_BANKS_CS", evt);
    },

    OnBankSortBy(evt) {
      this.sortBankCS = evt;
      this.$store.commit("SET_SORT_BANKS_CS", evt);
    },

    OnBankSortDesc(evt) {
      this.sortBankDesc = evt;
      this.$store.commit("SET_SORT_DESC_BANKS_CS", evt);
    },

    OnUpdateBankItemsPerPage(evt) {
      this.updateBankItemsPerPage = evt;
      this.$store.commit("SET_BANKS_PER_PAGE_CS", evt);
    },

    getBool(val) {
      if (val) return "Да";
      else return "Нет";
    },
    getColor(color) {
      if (color) return "red";
      return "transparent";
    },

    AddBank() {
      this.loading = true;
      this.$store
        .dispatch("addBankCS")
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "addbank" });
        })
        .catch((error) => {
          this.loading = false;
        });
    },

    editItem(item) {
      // this.editedIndex = this.desserts.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.dialog = true
      this.loading = true;
      this.$store
        .dispatch("getBankCS", item.id)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "editbank" });
        })
        .catch((error) => {
          this.loading = false;
        });
    },

    deleteItem(item) {
      Swal.fire({
        icon: "error",
        title: "Ошибка удаления",
        text: "Эта возможность пока еще не активирована во избежании удаления целого ряда банковских продуктов.",
      });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
  },
};
</script>
